import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';
import Breakpoints from '../../design-utils/breakpoints';

// This function creates a set of function that helps us create multipart component styles.
const helpers = createMultiStyleConfigHelpers([
  'stepper',
  'stepperItem',
  'stepItemLabel',
  'stepCounter',
  'checkMark',
]);

const Stepper = helpers.defineMultiStyleConfig({
  baseStyle: {
    stepper: {
      margin: '0 auto',
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: '20px',
      maxWidth: '700px',
      [`@media screen and (max-width: ${Breakpoints.md})`]: {
        marginBottom: '10px',
      },
    },
    stepperItem: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      flex: 1,
      '&::after': {
        position: 'absolute',
        content: '""',
        borderRadius: '1px',
        width: '80%',
        top: '10px',
        left: '60%',
        zIndex: 2,
        [`@media screen and (max-width: ${Breakpoints.md})`]: {
          width: '60%',
          left: '70%',
        },
        borderBottom:
          '2px solid var(--chakra-colors-stepper-stepperItem-stepperLine-incomplete)',
        '&[data-completed="true"]': {
          borderBottom:
            '2px solid var(--chakra-colors-stepper-stepperItem-stepperLine-complete)',
        },
      },
      '&[data-completed="true"]::after': {
        borderBottom:
          '2px solid var(--chakra-colors-stepper-stepperItem-stepperLine-complete)',
      },
      '&:last-child::after': {
        content: 'none',
      },
    },
    stepItemLabel: {
      color: 'stepper.label.color',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '14px',
      [`@media screen and (max-width: ${Breakpoints.md})`]: {
        fontSize: '12px',
      },
    },
    stepCounter: {
      position: 'relative',
      zIndex: 5,
      fontSize: '12px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '20px',
      height: '20px',
      borderRadius: ' 50%',
      marginBottom: '8px',
      background: 'stepper.stepCounter.background.incomplete',
      color: 'stepper.stepCounter.color.incomplete',
      [`&[data-current-step="true"]`]: {
        background: 'stepper.stepCounter.background.complete',
        color: 'stepper.stepCounter.color.complete',
      },
    },
    checkMark: {
      width: '16px',
      height: '16px',
      fill: 'white',
      fontStyle: 'normal',
    },
  },
  sizes: {},
  variants: {
    red: {
      stepperItem: {
        '&::after': {
          borderBottom: '2px solid #ff0000',
          '&[data-completed="true"]': {
            borderBottom: '2px solid #ff0000',
          },
        },
        '&[data-completed="true"]::after': {
          borderBottom: '2px solid #ff0000',
        },
      },
    },
  },
  defaultProps: {},
});

export default Stepper;
